const onboard = require('./image/onboard.png').default;
const logo = require('./image/logo.png').default;
const logoTemporary = require('./image/logo.png').default;
// Icons
const home = require('./icons/home_24px.svg').default;
const event = require('./icons/event_24px.svg').default;
const settings = require('./icons/settings_24px.svg').default;
const exitToApp = require('./icons/exit_to_app_24px.svg').default;
const accountBalance = require('./icons/account_balance_24px.svg').default;
const addCircleOutline = require('./icons/add_circle_outline_24px.svg').default;
const archive = require('./icons/archive_24px.svg').default;
const arrowBack = require('./icons/arrow_back_24px.svg').default;
const arrowDropDown = require('./icons/arrow_drop_down_24px.svg').default;
const arrowDropUp = require('./icons/arrow_drop_up_24px.svg').default;
const assignment = require('./icons/assignment_24px.svg').default;
const badge = require('./icons/badge.svg').default;
const block = require('./icons/block_24px.svg').default;
const business = require('./icons/business_24px.svg').default;
const cancel = require('./icons/cancel_24px.svg').default;
const cash = require('./icons/cash.svg').default;
const chromeReaderMode = require('./icons/chrome_reader_mode_24px.svg').default;
const compareArrow = require('./icons/compare_arrows_24px.svg').default;
const dateRange = require('./icons/date_range_24px.svg').default;
const trash = require('./icons/delete_24px.svg').default;
const description = require('./icons/description_24px.svg').default;
const domain = require('./icons/domain_24px.svg').default;
const done = require('./icons/done_24px.svg').default;
const doneAll = require('./icons/done_all_24px.svg').default;
const download = require('./icons/download_24px.svg').default;
const drafts = require('./icons/drafts_24px.svg').default;
const edit = require('./icons/edit_24px.svg').default;
const email = require('./icons/email_24px.svg').default;
const errorOutline = require('./icons/error_outline_24px.svg').default;
const eventBusy = require('./icons/event_busy_24px.svg').default;
const filter = require('./icons/filter_24px.svg').default;
const folderOpen = require('./icons/folder_open_24px.svg').default;
const formatListBulleted =
  require('./icons/format_list_bulleted_24px.svg').default;
const groups = require('./icons/groups.svg').default;
const hospital = require('./icons/hospital_24px.svg').default;
const howToReg = require('./icons/how_to_reg_24px.svg').default;
const indeterminateCheckBox =
  require('./icons/indeterminate_check_box_24px.svg').default;
const checkCircle = require('./icons/check_circle_24px.svg').default;
const info = require('./icons/info_24px.svg').default;
const insertChart = require('./icons/insert_chart_24px.svg').default;
const insertDriveFile = require('./icons/insert_drive_file_24px.svg').default;
const insertPdfFile = require('./icons/insert_pdf_file_24px.svg').default;
const keyboardArrowUp =
  require('./icons/keyboard_arrow_down_24px-1.svg').default;
const keyboardArrowDown =
  require('./icons/keyboard_arrow_down_24px.svg').default;
const keyboardArrowLeft =
  require('./icons/keyboard_arrow_left_24px.svg').default;
const keyboardArrowRight =
  require('./icons/keyboard_arrow_right_24px.svg').default;
const localHospital = require('./icons/local_hospital_24px.svg').default;
const map = require('./icons/map_24px.svg').default;
const moreHoriz = require('./icons/more_horiz_24px.svg').default;
const notificationsNone =
  require('./icons/notifications_none_24px.svg').default;
const outlinedFlag = require('./icons/outlined_flag_24px.svg').default;
const paste = require('./icons/paste_24px.svg').default;
const people = require('./icons/people_24px.svg').default;
const person = require('./icons/person_24px.svg').default;
const personAdd = require('./icons/person_add_24px.svg').default;
const personRemove = require('./icons/person_remove_24px.svg').default;
const phoneIphone = require('./icons/phone_iphone_24px.svg').default;
const photo = require('./icons/photo_24px.svg').default;
const photoCamera = require('./icons/photo_camera_24px.svg').default;
const place = require('./icons/place_24px.svg').default;
const playlistAdd = require('./icons/playlist_add_24px.svg').default;
const print = require('./icons/print_24px.svg').default;
const queryBuilder = require('./icons/query_builder_24px.svg').default;
const refresh = require('./icons/refresh_24px.svg').default;
const removeRedEye = require('./icons/remove_red_eye_24px.svg').default;
const repeat = require('./icons/repeat_24px.svg').default;
const search = require('./icons/search_24px.svg').default;
const search2 = require('./icons/search2_24px.svg').default;
const send = require('./icons/send_24px.svg').default;
const sms = require('./icons/sms_24px.svg').default;
const social = require('./icons/social_24px.svg').default;
const swapHoriz = require('./icons/swap_horiz_24px.svg').default;
const timeline = require('./icons/timeline_24px.svg').default;
const timer = require('./icons/timer_24px.svg').default;
const today = require('./icons/today_24px.svg').default;
const undo = require('./icons/undo_24px.svg').default;
const viewList = require('./icons/view_list_24px.svg').default;
const vpnKey = require('./icons/vpn_key_24px.svg').default;
const warningAmber = require('./icons/warning_amber_24px.svg').default;
const world = require('./icons/world-24px.svg').default;

export const appImages = {
  onboard,
  logo,
  logoTemporary,
};

export const icons = {
  home,
  howToReg,
  event,
  today,
  hospital,
  timeline,
  repeat,
  settings,
  exitToApp,
  print,
  accountBalance,
  addCircleOutline,
  archive,
  arrowBack,
  arrowDropDown,
  arrowDropUp,
  assignment,
  badge,
  block,
  business,
  cancel,
  cash,
  checkCircle,
  chromeReaderMode,
  compareArrow,
  dateRange,
  trash,
  description,
  domain,
  done,
  doneAll,
  download,
  drafts,
  edit,
  email,
  errorOutline,
  eventBusy,
  filter,
  folderOpen,
  groups,
  notificationsNone,
  keyboardArrowRight,
  keyboardArrowLeft,
  keyboardArrowDown,
  keyboardArrowUp,
  formatListBulleted,
  indeterminateCheckBox,
  info,
  insertChart,
  insertDriveFile,
  insertPdfFile,
  localHospital,
  map,
  moreHoriz,
  outlinedFlag,
  paste,
  people,
  person,
  personAdd,
  personRemove,
  phoneIphone,
  photo,
  photoCamera,
  place,
  playlistAdd,
  queryBuilder,
  refresh,
  removeRedEye,
  search,
  search2,
  send,
  sms,
  social,
  swapHoriz,
  timer,
  undo,
  viewList,
  vpnKey,
  warningAmber,
  world,
};
